// Import the necessary dependencies
import { usePathname } from 'next/navigation';

// Custom hook to check if the current page matches a given path
const useIsCurrentPage = (paths: string[]) => {
    // Access the router object
    const pathname = usePathname()
    
    // Check if it's the current page
    const isCurrentPage = paths?.includes(pathname) || pathname?.includes(paths[0]);

    return isCurrentPage;
};

export default useIsCurrentPage;